import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Wrapper, ActionWrapper, IconWrapper } from './cookies.styles';
import { Typography } from '@shared/ui/typography/typography';
import { IconCookies } from '@shared/icon/icon-cookies/icon-cookies';
import { Button } from '@vtbhome/juicyfront';
import { createPortal } from 'react-dom';
import { COOKIES_NOTIFY_ID } from '../cookies/constants';

export const Cookies: React.FC = () => {
    const cookiesRef = useRef<HTMLDivElement | null>(null);
    const [isMounted, setIsMounted] = useState(false);
    const [isShow, setIsShow] = useState(false);

    useEffect(() => {
        const cookiesContainer = document.getElementById(`${COOKIES_NOTIFY_ID}`) as HTMLDivElement;
        cookiesRef.current = cookiesContainer;
        if (cookiesContainer) {
            setIsMounted(true);
        }
    }, []);

    useEffect(() => {
        if (!localStorage.getItem(`${COOKIES_NOTIFY_ID}`)) {
            setIsShow(true);
        }
    }, []);

    const acceptCookie = useCallback(() => {
        setIsShow(false);
        localStorage.setItem(`${COOKIES_NOTIFY_ID}`, 'accepted');
    }, []);

    return (
        <>
            {isMounted &&
                cookiesRef.current &&
                createPortal(
                    <Wrapper isShow={isShow}>
                        <IconWrapper>
                            <IconCookies />
                        </IconWrapper>
                        <ActionWrapper>
                            <Typography size='subtitle3' color='neutral_90' as='p'>
                                <b>Мы используем куки на всех страницах сайта</b>
                            </Typography>
                            <Typography size='subtitle3' color='neutral_90' as='p'>
                                Используя сайт, вы соглашаетесь с использованием файлов кук.
                            </Typography>
                            <Button size='s' buttonType='light' onClick={acceptCookie}>
                                Прекрасно
                            </Button>
                        </ActionWrapper>
                    </Wrapper>,
                    cookiesRef.current
                )}
        </>
    );
};
